import React, { useState } from "react";
import axios from "axios";


const useZ3950 = ({
    api = '/koha/bib/z3950',
    // api = '/cataloging/backend/z3950/multi',
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck([])

    const getZ3950Providers = () => {
        return axios.get(`${api}/providers`)
            .then((response) => response?.data?.data ?? [])
    }

    const getZ3950Data = (params) => {
        onBefore({
            axiosMode: "get",
            api: 'Z3950Data'
        })
        // return axios.get(api, {
        //     params: {
                
                
        //         "marcdata": "json",
        //         "search": [
        //         ],
        //         "servers": [
        //             {
        //                 "name": "逢甲大學",
        //                 "host": "innopac.lib.fcu.edu.tw",
        //                 "port": 210,
        //                 "db": "INNOPAC",
        //                 "syntax": "usmarc",
        //                 "attr_map_title": "1=4",
        //                 "attr_map_author": "1=1003",
        //                 "attr_map_isbn": "1=7",
        //                 "attr_map_issn": "1=8"
        //             },
        //             {
        //                 "name": "師範大學",
        //                 "host": "opac.lib.ntnu.edu.tw",
        //                 "port": 210,
        //                 "db": "INNOPAC",
        //                 "syntax": "usmarc",
        //                 "attr_map_title": "1=4",
        //                 "attr_map_author": "1=1003",
        //                 "attr_map_isbn": "1=7",
        //                 "attr_map_issn": "1=8"
        //             },
        //         ],
        //         ...params,


        //     },
        // })
        return axios.get(api, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            api: 'Z3950Data',
                            values: data?.data,
                            ...data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            api: 'Z3950Data'
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postZ3950Data = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/koha/bib/z3950',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchZ3950Data = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/koha/bib/z3950',
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteZ3950Data = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/koha/bib/z3950',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        Z3950Data: data,
        getZ3950Providers,
        getZ3950Data,
        postZ3950Data,
        patchZ3950Data,
        deleteZ3950Data,
    }
}
export { useZ3950 }



const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
